import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSpinner = _resolveComponent("AppSpinner")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.is), {
    type: !_ctx.to && _ctx.type,
    class: _normalizeClass(["relative cursor-pointer inline-flex justify-center items-center font-bold border-2 active:scale-95 transform transition-all duration-200 ease-in-out", _ctx.classes]),
    to: _ctx.to && _ctx.to,
    href: _ctx.href && _ctx.href,
    disabled: _ctx.props.loading || _ctx.props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!(_ctx.props.loading || _ctx.props.disabled) && _ctx.$emit('click', $event)))
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_AppSpinner, {
            key: 0,
            class: "-ml-7 mr-2 pointer-events-none"
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["type", "class", "to", "href", "disabled"]))
}